export default __webpack_public_path__ + "static/media/sample2.5da134c9.png";